import { useMemo } from "react";
import { API_BASE_URL } from "../config/api";
import { createDashboardApi } from "../services/dashboardApi";
import { createBrokerDashboardApi } from "../services/brokerDashboardApi";
import { createDeveloperDashboardApi } from "../services/developerDashboardApi";
import { createOwnerDashboardApi } from "../services/ownerDashboardApi";

export const useDashboardClients = () => {
  const getToken = () =>
    sessionStorage.getItem("token") || localStorage.getItem("token");

  const dashboardApi = useMemo(
    () => createDashboardApi(API_BASE_URL, getToken),
    [],
  );
  const brokerDashboardApi = useMemo(() => createBrokerDashboardApi(), []);
  const developerDashboardApi = useMemo(() => createDeveloperDashboardApi(), []);
  const ownerDashboardApi = useMemo(() => createOwnerDashboardApi(), []);

  return {
    dashboardApi,
    brokerDashboardApi,
    developerDashboardApi,
    ownerDashboardApi,
  };
};
